const NEEDS_QUOTING = /[",\r\n]/;
// Cells beginning with these characters are interpreted as formulas by
// Excel and Google Sheets. Prefix with a single quote to neutralize.
const FORMULA_TRIGGER = /^[=+\-@\t\r]/;

const escapeCell = (value) => {
  if (value === null || value === undefined) return '';
  const raw = String(value);
  const safe = FORMULA_TRIGGER.test(raw) ? `'${raw}` : raw;
  if (!NEEDS_QUOTING.test(safe)) return safe;
  return `"${safe.replace(/"/g, '""')}"`;
};

/**
 * Serialize rows to an RFC 4180 CSV string with formula-injection guards.
 *
 * @param {ReadonlyArray<object>} rows
 * @param {ReadonlyArray<{ header: string, value: (row: object) => unknown }>} columns
 * @returns {string}
 */
export const toCsv = (rows, columns) => {
  const header = columns.map(c => escapeCell(c.header)).join(',');
  const body = rows
    .map(row => columns.map(c => escapeCell(c.value(row))).join(','))
    .join('\r\n');
  return body ? `${header}\r\n${body}\r\n` : `${header}\r\n`;
};

/**
 * Trigger a browser download of `content` as `filename`.
 *
 * @param {string} filename
 * @param {string} content
 */
export const downloadCsv = (filename, content) => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
